import type { InternalAxiosRequestConfig } from "axios";
import axios, { AxiosHeaders } from "axios";

/** HTTP client for anonymous public flows (e.g. signed participant-list links). No Firebase Bearer. */
export const przezmorzePublicApi = axios.create({
  baseURL: "/api",
  timeout: 30 * 1000, // 30 seconds
});

przezmorzePublicApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers = AxiosHeaders.from(config.headers ?? {});
  config.headers.delete("Authorization");
  return config;
});
